import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import Field from "../sections/MUI/Field";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";
import req from "../req";
import config from "../config";
import Select from "../sections/MUI/Select";

class Estelam extends Component {

    state = {
        result: [],

        by: "شماره",

        name: "",
        limit: "10",
        phone: "09",
        code: ""
    };


    submit() {
        let {by, name, phone, limit, code} = this.state;
        by = by ? by.toString().trim() : "شماره";
        name = name ? name.toString().trim() : "";
        phone = phone.toString().replace(/ /g, "").trim();
        limit = limit.toString().trim();
        if (by === "شماره") {
            if (!phone.startsWith("09") || phone.length !== 11) {
                return toast.error("شماره موبایل را دقیق وارد کنید!");
            }
            toast.info(`در حال استعلام برای "${phone}" ...`, {autoClose: 3000});
        } else if (by === "اسم") {
            if (name.length < 3) {
                return toast.error("نام و نام خانوادگی باید حداق 3 کاراکتر داشته باشد و دقیق وارد شود!");
            }
            toast.info(`در حال استعلام برای "${name}" ...`, {autoClose: 3000});
        } else if (by === "کدملی") {
            if (code.length < 8) {
                return toast.error("کد ملی صحیح نیست!");
            }
            toast.info(`در حال استعلام برای "${code}" ...`, {autoClose: 3000});

        }
        if (limit === "") {
            limit = "10";
        }
        if (!isNaN(Number(limit))) {
            limit = Number(limit);
        } else {
            limit = 10;
        }
        req.post(`/est/by-phone`, {
            by,
            name,
            phone,
            code,
            limit
        }).then(r => {
            console.log(r);
            if (r) {
                if (r.result) {
                    let json = config.decodeBase64(r.result);
                    if (json) {
                        try {
                            let arr = JSON.parse(json);
                            if (arr) {
                                if (Array.isArray(arr)) {
                                    let finalArr = [];

                                    arr.map(it => {
                                        let item = it;
                                        try {
                                            if (item.db) {
                                                if (item.db.toString() !== "") {
                                                    item.db = config.decodeBase64(item.db);
                                                }
                                            }
                                        } catch (err) {
                                        }
                                        Object.keys(item).map((key) => {
                                            let fk = key.replace(/\_/g, "").trim().toLowerCase();
                                            item[fk] = item[key];
                                            if (key !== fk) {
                                                delete item[key];
                                            }
                                        });
                                        finalArr.push(item);
                                    });

                                    if (finalArr.length === 0) {
                                        toast.error("موردی پیدا نشد!");
                                    } else {
                                        toast.success(`${finalArr.length} مورد پیدا شد!`);
                                    }
                                    finalArr = finalArr.map(it => {
                                        let item = it;
                                        try {
                                            if (item["birthdate"]) {
                                                item["birthdate"] = item["birthdate"]?.toString().trim()
                                                    .replace(/\-/g, "/")
                                                    .trim();
                                            }
                                        } catch (err) {
                                        }
                                        try {
                                            if (item["phone"]) {
                                                item["phone"] = item["phone"]?.toString();
                                                if (item["phone"].startsWith("9")) {
                                                    item["phone"] = `0${item["phone"]}`;
                                                }
                                            }
                                            if (item["phonenumber"]) {
                                                item["phonenumber"] = item["phonenumber"]?.toString();
                                                if (item["phonenumber"].startsWith("9")) {
                                                    item["phonenumber"] = `0${item["phonenumber"]}`;
                                                }
                                            }
                                            if (item["mobile"]) {
                                                item["mobile"] = item["mobile"]?.toString();
                                                if (item["mobile"].startsWith("9")) {
                                                    item["mobile"] = `0${item["mobile"]}`;
                                                }
                                            }
                                        } catch (err) {
                                        }
                                        return item;
                                    })
                                    return this.setState({result: finalArr});
                                }
                            }
                        } catch (err) {
                        }
                    }
                    toast.info(json);
                }
            }
            return toast.error("خطایی رخ داد!");
        });
    }

    getKeyName(key = "") {
        key = key ? key.toString().trim().toLowerCase() : "";
        return config.getEstelamKeyName(key);
    }

    color(key = "") {
        return config.getEstelamColor(key);
    }

    render() {
        let {result, by, name, phone, code, limit} = this.state;
        return (
            <div className="estelam">
                <Back {...this.props}/>
                <br/>
                <div className="row justify-content-center">
                    <div className="col-xl-4 col-lg-5 col-md-7">
                        <Select simple
                                name="by"
                                value={by}
                                label="استعلام بر اساس"
                                onChange={(name, value) => {
                                    this.setState({
                                        result: [],
                                        [name]: value,
                                        name: "",
                                        phone: "09"
                                    });

                                }}
                                options={[
                                    {t: "شماره", v: "شماره"},
                                    {t: "اسم", v: "اسم"},
                                    {t: "کدملی", v: "کدملی"}
                                ]}/>
                    </div>
                </div>
                <br/>
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        {
                            by === "شماره" ?
                                <Field name="phone"
                                       type="number"
                                       value={phone}
                                       maxLength={11}
                                       label="شماره موبایل (با 09 شروع شود و دقیق باشد 11 رقمی)"
                                       style={{direction: "ltr"}}
                                       onChange={(name, value) => this.setState({[name]: value})}/>
                                :
                                null
                        }
                        {
                            by === "کدملی" ?
                                <Field name="code"
                                       type="number"
                                       value={code}
                                       maxLength={11}
                                       label="کد ملی (دقیق)"
                                       style={{direction: "ltr"}}
                                       onChange={(name, value) => this.setState({[name]: value})}/>

                                : null
                        }
                        {
                            by === "اسم" ?
                                <Field name="name"
                                       value={name}
                                       maxLength={200}
                                       type="text"
                                       label="نام و نام خانوادگی (دقیق)"
                                       onChange={(n, v) => this.setState({
                                           [n]: v.toString()
                                               .replace("-", " ")
                                               .replace("_", " ")
                                               .replace("+", " ")
                                               .replace(/\d+/g, "")
                                       })}/>
                                : null
                        }

                    </div>
                    {
                        by === "اسم" ?
                            <div className="col-md-3">
                                <Field
                                    type="number"
                                    label="حداکثر تعداد"
                                    name="limit"
                                    value={limit}
                                    maxLength={3}
                                    onChange={(name, value) => {
                                        value = value.toString().trim();
                                        if (value === "") {
                                            return this.setState({[name]: ""});
                                        }
                                        let v = Number(value);
                                        if (isNaN(v)) {
                                            v = "";
                                        } else {
                                            if (v < 1) {
                                                v = "1";
                                            } else if (v > 250) {
                                                v = "250";
                                            }
                                        }
                                        v = v.toString().trim();
                                        this.setState({[name]: v});
                                    }}/>
                            </div>
                            : null
                    }

                    <div className="col-md-3">
                        <Button icon="refresh" onClick={() => this.submit()}>دریافت استعلام</Button>
                    </div>
                </div>

                <br/>
                <h1>تعداد:&nbsp;{result.length}</h1>
                <br/>
                {
                    result.length > 0 ?
                        <div className="list">
                            {
                                result.map((it, i) =>
                                    <article key={"est" + i}>
                                        {Object.keys(it).map((key, i2) => (
                                            <p key={"est" + i + "p" + i2}>
                                                <span>{this.getKeyName(key)}:</span>
                                                <span
                                                    style={{color: this.color(key)}}>{it[key]}</span>
                                            </p>
                                        ))}
                                    </article>
                                )
                            }
                        </div>
                        : null
                }
            </div>
        );
    }
}

export default gpn(Estelam);